// extracted by mini-css-extract-plugin
export var blogPost = "article-post-module--blog-post--x0LFP";